.found-in {
  padding-right: var(--eg-theme-space-xs);
}
